<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { required } from "vuelidate/lib/validators";
import { cloneDeep } from "lodash";
import groupBy from "lodash/groupBy";
import Multiselect from "vue-multiselect";
import Details from "@/router/views/dts/dts-modal/details";
import Logs from "@/router/views/dts/dts-modal/logs";
import Rating from "@/router/views/dts/dts-modal/satisfactory-rating";
import Tracks from "@/components/modals/document-tracks.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import RawData from "@/components/widgets/raw-data.vue";

export default {
  page: {
    title: "Office Tracks"
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    Details,
    Logs,
    Rating,
    Tracks,
    PrintOptions,
    RawData
  },
  data() {
    return {
      title: "Office Tracks",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Incoming Tracks",
          href: "/dts/incoming-tracks"
        },
        {
          text: "Office Tracks",
          active: true
        }
      ],
      modalTitle: "",
      tableData: [],
      selectAll: false,
      filter: "",
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      perPageItem: 10,
      loading: false,
      form: {
        deliveryUnitId: "",
        departmentId: "",
        title: "",
        description: "",
        destinationDepartmentId: "",
        destinationDepartment: [{ departmentName: "N/A", id: 0 }],
        destinationDeliveryUnitId: "",
        destinationDeliveryUnit: null,
        destinationCampus: null,
        processTypeId: "",
        processType: null,
        actionNeeded: "",
        actionType: null,
        documents: [],
        document: "",
        tracks: []
      },
      campusOptions: [],
      departmentOptions: [],
      processTypeOptions: [],
      actionTypeOptions: [],
      formLoading: false,
      campusId: this.$store.state.data.selectedCampus.id,
      selectedDU: this.$store.state.data.selectedDU.id,
      selectedDepartment: this.$store.state.data.selectedDepartment.id,
      tabIndex: 0,
      tableSort: {
        sortBy: "",
        trackReverse: true,
        destinationReverse: false,
        processReverse: false,
        durationReverse: false,
        statusReverse: false
      },
      showAllCampus: false,
      dus: [],
      processTypesDUs: []
    };
  },
  validations: {
    form: {
      title: { required },
      description: { required },
      destinationDeliveryUnit: { required },
      destinationCampus: { required },
      processType: { required },
      actionType: { required },
      documents: { required }
    }
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (item.title) {
            if (item.title.toUpperCase().includes(this.filter.toUpperCase()))
              return item.title
                .toUpperCase()
                .includes(this.filter.toUpperCase());
          }
          if (item.description) {
            if (
              item.description.toUpperCase().includes(this.filter.toUpperCase())
            )
              return item.description
                .toUpperCase()
                .includes(this.filter.toUpperCase());
          }
          if (item.referenceNumber) {
            if (
              item.referenceNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase())
            )
              return item.referenceNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
          }
        });
      }
      return data;
    },
    paginated() {
      let data = this.filtered;
      var total = this.currentPage * this.perPage;
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPage > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      return currentData;
    },
    rows() {
      return this.filtered.length;
    }
  },
  watch: {
    "showAllCampus": function(value) {
      this.form.destinationCampus = null;
      this.form.destinationDeliveryUnit = null;
      this.form.destinationDepartment = null;
      this.form.destinationDepartmentId = "";
      if(value){
        this.campusOptions = this.groupDu(this.dus);
      }else{
        this.campusOptions = this.groupDu(this.processTypesDUs);
      }
    },
  },
  created() {
    this.changeCampus();
    this.getAllDUs();
  },
  methods: {
    async getAllDUs() {
      this.$store
        .dispatch("deliveryunit/GetDeliveryUnit")
        .then((res) => {
          if(res.data.error){
            return this.showToast(res.data.errorMessage, "error");
          }
          this.dus = res.data.sort(function(a, b) {
            if (a.name.trim() .trim()< b.name.trim()) {
              return -1;
            }
            if (a.name.trim() > b.name.trim()) {
              return 1;
            }
            return 0;
          }).filter(item => !item.office.campus.campusName.toLowerCase().includes('test')).map((item) => {
            return {
              id: item.id,
              name: item.name.trim(),
              campusId: item.office.campusId,
              campus: item.office.campus.campusName
            };
          });
        })
        .catch((err) => {
          this.showToast("Something went wrong - Getting campuses!", "error");
        });
    },
    changeCampus() {
      this.campusId = this.$store.state.data.selectedCampus.id;
      this.selectedDU = this.$store.state.data.selectedDU.id;
      this.selectedDepartment = this.$store.state.data.selectedDepartment.id;
      if (this.tabIndex == 0) this.getDraft();
      else if (this.tabIndex == 1) this.getInProcess();
      else if (this.tabIndex == 2) this.getProcessed();
    },
    sortData(sortBy) {
      if (sortBy == "track") {
        if (this.tableSort.sortBy == sortBy) {
          this.tableSort.trackReverse = !this.tableSort.trackReverse;
        } else {
          this.tableSort.sortBy = sortBy;
        }
        this.tableData = this.tableData.sort(function(a, b) {
          if (a.id < b.id) {
            return -1;
          }
          if (a.id > b.id) {
            return 1;
          }
          return 0;
        });
        if (this.tableSort.trackReverse) this.tableData.reverse();
      } else if (sortBy == "destination") {
        if (this.tableSort.sortBy == sortBy) {
          this.tableSort.destinationReverse = !this.tableSort
            .destinationReverse;
        } else {
          this.tableSort.sortBy = sortBy;
        }
        this.tableData = this.tableData.sort(function(a, b) {
          if (a.destinationDeliveryUnit.name < b.destinationDeliveryUnit.name) {
            return -1;
          }
          if (a.destinationDeliveryUnit.name > b.destinationDeliveryUnit.name) {
            return 1;
          }
          return 0;
        });
        if (this.tableSort.destinationReverse) this.tableData.reverse();
      } else if (sortBy == "processType") {
        if (this.tableSort.sortBy == sortBy) {
          this.tableSort.processReverse = !this.tableSort.processReverse;
        } else {
          this.tableSort.sortBy = sortBy;
        }
        this.tableData = this.tableData.sort(function(a, b) {
          if (a.processType.processName < b.processType.processName) {
            return -1;
          }
          if (a.processType.processName > b.processType.processName) {
            return 1;
          }
          return 0;
        });
        if (this.tableSort.processReverse) this.tableData.reverse();
      } else if (sortBy == "duration") {
        if (this.tableSort.sortBy == sortBy) {
          this.tableSort.durationReverse = !this.tableSort.durationReverse;
        } else {
          this.tableSort.sortBy = sortBy;
        }
        this.tableData.forEach((item) => {
          item.processDuration = this.processDuration(item);
        });
        this.tableData = this.tableData.sort(function(a, b) {
          if (a.processDuration < b.processDuration) {
            return -1;
          }
          if (a.processDuration > b.processDuration) {
            return 1;
          }
          return 0;
        });
        if (this.tableSort.durationReverse) this.tableData.reverse();
      } else if (sortBy == "status") {
        if (this.tableSort.sortBy == sortBy) {
          this.tableSort.statusReverse = !this.tableSort.statusReverse;
        } else {
          this.tableSort.sortBy = sortBy;
        }
        this.tableData = this.tableData.sort(function(a, b) {
          if (a.status < b.status) {
            return -1;
          }
          if (a.status > b.status) {
            return 1;
          }
          return 0;
        });
        if (this.tableSort.statusReverse) this.tableData.reverse();
      }
    },
    getDraft() {
      this.loading = true;
      this.tableSort = {
        sortBy: "",
        trackReverse: true,
        destinationReverse: false,
        processReverse: false,
        durationReverse: false,
        statusReverse: false
      };
      this.$store
        .dispatch("dtstrack/GetDraftTrack", {
          deliveryUnitId: this.selectedDU,
          departmentId: 0
        })
        .then((res) => {
          this.tableData = res.data;
          this.sortData("track");
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting draft tracks!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    getInProcess() {
      this.loading = true;
      this.tableSort = {
        sortBy: "",
        trackReverse: true,
        destinationReverse: false,
        processReverse: false,
        durationReverse: false,
        statusReverse: false
      };
      this.$store
        .dispatch("dtstrack/GetInProcessTrack", {
          deliveryUnitId: this.selectedDU,
          departmentId: 0
        })
        .then((res) => {
          this.selectAll = false;
          res.data.forEach((item) => {
            item.selected = false;
          });
          this.tableData = res.data;
          this.sortData("track");
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting pending tracks!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    getProcessed() {
      this.loading = true;
      this.tableSort = {
        sortBy: "",
        trackReverse: true,
        destinationReverse: false,
        processReverse: false,
        durationReverse: false,
        statusReverse: false
      };
      this.$store
        .dispatch("dtstrack/GetCompletedTrack", {
          deliveryUnitId: this.selectedDU,
          departmentId: 0
        })
        .then((res) => {
          this.selectAll = false;
          res.data.forEach((item) => {
            item.selected = false;
          });
          this.tableData = res.data;
          this.sortData("track");
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting processed tracks!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    onSubmit(type) {
      this.submitted = true;
      this.$v.form.$touch();
      if (this.$v.form.$invalid || this.form.documents.length == 0) {
        return;
      }
      this.form.destinationDeliveryUnitId = this.form.destinationDeliveryUnit.id;
      this.form.destinationDepartmentId = this.form.destinationDepartment.id;
      this.form.processTypeId = this.form.processType.id;
      if (this.form.actionType.type != "Others")
        this.form.actionNeeded = this.form.actionType.type;
      if (this.form.id) {
        this.$store
          .dispatch("dtstrack/UpdateTrack", this.form)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            if (type == "update") {
              var index = this.tableData.findIndex(
                (item) => item.id == this.form.id
              );
              this.tableData.splice(index, 1, this.form);
            } else {
              this.$store
                .dispatch("dtstrack/PostTrack", this.form.id)
                .then((res) => {
                  if (res.data.error) {
                    return this.showToast(res.data.errorMessage, "error");
                  }
                  let dashboardData = JSON.parse(
                    localStorage.getItem("dashboardData")
                  );
                  dashboardData.incomingTracks =
                    dashboardData.incomingTracks + 1;
                  localStorage.setItem(
                    "dashboardData",
                    JSON.stringify(dashboardData)
                  );
                  this.viewDetails(res.data.id);
                  var index = this.tableData.findIndex(
                    (item) => item.id == this.form.id
                  );
                  this.tableData.splice(index, 1);
                })
                .catch((err) => {
                  this.showToast("Cannot be sent!", "error");
                });
            }
            this.$bvModal.hide("modal-documentTrack");
            this.showToast("Successfully updated!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      } else {
        this.$store
          .dispatch("dtstrack/CreateTrack", this.form)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            if (this.form.tracks.length > 0) {
              var newTrack = res.data;
              this.$store
                .dispatch("dtstrack/MergeTrack", {
                  parentId: newTrack.id,
                  array: this.form.tracks
                })
                .then((res) => {
                  if (res.data.error) {
                    return this.showToast(res.data.errorMessage, "error");
                  }
                  if (type == "create") {
                    this.tableData.unshift(newTrack);
                  } else {
                    this.$store
                      .dispatch("dtstrack/PostTrack", newTrack.id)
                      .then((res) => {
                        if (res.data.error) {
                          return this.showToast(res.data.errorMessage, "error");
                        }
                        let dashboardData = JSON.parse(
                          localStorage.getItem("dashboardData")
                        );
                        dashboardData.incomingTracks =
                          dashboardData.incomingTracks + 1;
                        localStorage.setItem(
                          "dashboardData",
                          JSON.stringify(dashboardData)
                        );
                        this.viewDetails(newTrack.id);
                      })
                      .catch((err) => {
                        this.showToast("Cannot be sent!", "error");
                      });
                  }
                  this.$bvModal.hide("modal-documentTrack");
                  this.showToast("Successfully created!", "success");
                });
            } else {
              if (type == "create") {
                this.tableData.unshift(res.data);
              } else {
                this.$store
                  .dispatch("dtstrack/PostTrack", res.data.id)
                  .then((res) => {
                    if (res.data.error) {
                      return this.showToast(res.data.errorMessage, "error");
                    }
                    let dashboardData = JSON.parse(
                      localStorage.getItem("dashboardData")
                    );
                    dashboardData.incomingTracks =
                      dashboardData.incomingTracks + 1;
                    localStorage.setItem(
                      "dashboardData",
                      JSON.stringify(dashboardData)
                    );
                    this.viewDetails(res.data.id);
                  })
                  .catch((err) => {
                    this.showToast("Cannot be sent!", "error");
                  });
              }
              this.$bvModal.hide("modal-documentTrack");
              this.showToast("Successfully created!", "success");
            }
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      }
    },
    createTrack() {
      this.formLoading = true;
      this.modalTitle = "Create Track";
      this.$bvModal.show("modal-documentTrack");
      this.onReset();
      this.getProcessType();
      this.getActionType();
      this.formLoading = false;
    },
    async updateTrack(props) {
      this.formLoading = true;
      this.modalTitle = "Update Track";
      this.$bvModal.show("modal-documentTrack");
      await this.onReset();
      await this.getProcessType();
      await this.getActionType();
      this.form.id = cloneDeep(props.id);
      this.form.title = cloneDeep(props.title);
      this.form.description = cloneDeep(props.description);
      await this.getDocuments(this.form);
      this.form.processType = cloneDeep(props.processType);
      await this.getDeliveryUnit();
      this.$store
        .dispatch("dtsprocesstype/GetDUByProcessType", this.form.processType.id)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.campusOptions = this.groupDu(
            res.data
              .sort(function(a, b) {
                if (a.name < b.name) {
                  return -1;
                }
                if (a.name > b.name) {
                  return 1;
                }
                return 0;
              })
              .filter((item) => {
                return this.selectedDU != item.id;
              })
          );
          this.form.destinationCampus = this.campusOptions.find(
            (x) => x.campusId == props.destinationDeliveryUnit.campusId
          );
          this.form.destinationDeliveryUnit = cloneDeep(
            props.destinationDeliveryUnit
          );
          this.form.destinationDepartment = props.destinationDepartment
            ? cloneDeep(props.destinationDepartment)
            : [{ departmentName: "N/A", id: 0 }];
          this.form.actionType = { type: props.actionNeeded };
          this.formLoading = false;
        });
    },
    deleteTrack(props) {
      this.$swal({
        position: "top",
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dtstrack/DeleteTrack", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var index = this.tableData.findIndex(
                (item) => item.id == props.id
              );
              this.tableData.splice(index, 1);
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    postTrack(props) {
      this.$swal({
        position: "top",
        title: "Are you sure?",
        text: "You are about to send this track.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, send it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dtstrack/PostTrack", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let dashboardData = JSON.parse(
                localStorage.getItem("dashboardData")
              );
              dashboardData.incomingTracks = dashboardData.incomingTracks + 1;
              if (props.status == "RETURNED")
                dashboardData.returnedTracks = dashboardData.returnedTracks - 1;
              localStorage.setItem(
                "dashboardData",
                JSON.stringify(dashboardData)
              );
              this.viewDetails(res.data.id);
              var index = this.tableData.findIndex(
                (item) => item.id == props.id
              );
              this.tableData.splice(index, 1);
              this.showToast("Successfully sent", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be sent!", "error");
            });
        }
      });
    },
    unsendTrack(props) {
      this.$swal({
        position: "top",
        title: "Are you sure?",
        text: "You are about to unsend this track.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ff9f43",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, unsend track!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dtstrack/UnsendTrack", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var index = this.tableData.findIndex(
                (item) => item.id == props.id
              );
              this.tableData.splice(index, 1);
              this.showToast("Successfully unsent", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be unsent!", "error");
            });
        }
      });
    },
    async onReset() {
      this.submitted = false;
      this.form = {
        deliveryUnitId: this.selectedDU,
        departmentId: 0,
        title: "",
        description: "",
        destinationDepartmentId: "",
        destinationDepartment: [{ departmentName: "N/A", id: 0 }],
        destinationDeliveryUnitId: "",
        destinationDeliveryUnit: null,
        destinationCampus: null,
        processTypeId: "",
        processType: null,
        actionNeeded: "",
        actionType: null,
        documents: [],
        document: "",
        tracks: []
      };
      this.campusOptions = [];
      this.processTypeOptions = [];
      this.actionTypeOptions = [];
    },
    addDocument() {
      if (this.form.document.trim() != "") {
        this.form.documents.push(this.form.document);
        this.form.document = "";
      }
    },
    removeDocument(index) {
      this.form.documents.splice(index, 1);
    },
    async changeProcessType() {
      await this.getDeliveryUnit();
      this.form.actionNeeded = "";
      this.form.actionType = null;
      this.form.destinationDepartmentId = "";
      this.form.destinationDepartment = [{ departmentName: "N/A", id: 0 }];
      this.form.destinationDeliveryUnitId = "";
      this.form.destinationDeliveryUnit = null;
      this.form.destinationCampus = null;
    },
    viewDetails(id) {
      this.$refs.details.getData(id);
    },
    viewLogs(id) {
      this.$refs.logs.getData(id);
    },
    trackRating(trackId) {
      this.$refs.rating.setRating(trackId, this.selectedDU);
    },
    saveRating(trackId) {
      var index = this.tableData.findIndex((item) => item.id == trackId);
      this.tableData[index].withRating = true;
    },
    async getDocuments(props) {
      this.$store
        .dispatch("dtstrackdocument/GetTrackDocument", props.id)
        .then((res) => {
          for (var count = 0; count < res.data.length; count++) {
            props.documents.push(res.data[count].title);
          }
        });
    },
    groupDu(props) {
      var array = [];
      var x = groupBy(props, "campusId");
      for (const key in x) {
        array.push({
          campusId: key,
          campus: x[key][0].campus,
          deliveryUnitOptions: x[key]
        });
      }
      return array;
    },
    async getDeliveryUnit() {
      this.$store
        .dispatch("dtsprocesstype/GetDUByProcessType", this.form.processType.id)
        .then((res) => {
          if(res.data.error){
            return this.showToast(res.data.errorMessage, "error");
          }
          this.processTypesDUs = res.data.sort(function(a, b) {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          });
          this.campusOptions = this.groupDu(this.processTypesDUs);
        });
    },
    async getDepartment(duId) {
      this.form.destinationDepartment = [{ departmentName: "N/A", id: 0 }];
      this.$store.dispatch("department/GetDepartmentByDU", duId).then((res) => {
        if (res.data.error || res.data.length < 2) {
          return;
        }
        this.departmentOptions = res.data
          .sort(function(a, b) {
            if (a.departmentName < b.departmentName) {
              return -1;
            }
            if (a.departmentName > b.departmentName) {
              return 1;
            }
            return 0;
          })
          .filter((item) => {
            return this.selectedDepartment != item.id;
          });
        this.departmentOptions.unshift({ departmentName: "N/A", id: 0 });
      });
    },
    campusLabel({ campus }) {
      return `${campus}`;
    },
    deliveryUnitLabel({ name }) {
      return `${name}`;
    },
    departmentLabel({ departmentName }) {
      return `${departmentName}`;
    },
    async getProcessType() {
      this.$store.dispatch("dtsprocesstype/GetProcessType").then((res) => {
        this.processTypeOptions = res.data.sort(function(a, b) {
          if (a.processName < b.processName) {
            return -1;
          }
          if (a.processName > b.processName) {
            return 1;
          }
          return 0;
        });
      });
    },
    processTypeLabel({ processName }) {
      return `${processName}`;
    },
    async getActionType() {
      this.$store.dispatch("dtsactiontype/GetActionType").then((res) => {
        this.actionTypeOptions = res.data.sort(function(a, b) {
          if (a.type < b.type) {
            return -1;
          }
          if (a.type > b.type) {
            return 1;
          }
          return 0;
        });
        this.actionTypeOptions.push({ type: "Others" });
      });
    },
    async refreshOptions() {
      this.formLoading = true;
      await this.getProcessType();
      await this.getActionType();
      if (this.form.processType) {
        await this.getDeliveryUnit();
        if (this.form.destinationCampus) {
          let campusId = this.form.destinationCampus.campusId;
          this.form.destinationCampus = this.campusOptions.find(
            (x) => x.campusId == campusId
          );
        }
      }
      setTimeout(() => {
        this.formLoading = false;
      }, 500);
    },
    getTracks() {
      this.$refs.tracks.setData(this.form.tracks, this.selectedDU, 0);
      this.$bvModal.show("tracks-modal");
    },
    dropTracks(data) {
      this.form.tracks = data.concat(this.form.tracks);
    },
    actionTypeLabel({ type }) {
      return `${type}`;
    },
    resetSelected() {
      this.selectAll = false;
      this.tableData.forEach((item) => {
        item.selected = false;
      });
    },
    selectAllItems() {
      this.paginated.forEach((item) => {
        item.selected = false;
      });
      if (this.selectAll === true) {
        this.paginated.forEach((item) => {
          item.selected = true;
        });
      }
    },
    checkSelected(data) {
      var count = 0;
      data.forEach((item) => {
        if (item.selected) count++;
      });
      if (count === this.perPage) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    },
    checkForSelected() {
      var count = 0;
      this.tableData.forEach((item) => {
        if (item.selected) count++;
      });
      if (count > 0) return true;
      else return false;
    },
    processDuration(props) {
      if (props.status != "RECEIVED") return 0;
      var dDate1 = new Date(props.dateTimeReceived);
      var dDate2 = new Date();
      var iWeeks,
        iDateDiff,
        iAdjust = 0;
      if (dDate2 < dDate1) return -1;
      var iWeekday1 = dDate1.getDay();
      var iWeekday2 = dDate2.getDay();
      iWeekday1 = iWeekday1 == 0 ? 7 : iWeekday1;
      iWeekday2 = iWeekday2 == 0 ? 7 : iWeekday2;
      if (iWeekday1 > 5 && iWeekday2 > 5) iAdjust = 1;
      iWeekday1 = iWeekday1 > 5 ? 5 : iWeekday1;
      iWeekday2 = iWeekday2 > 5 ? 5 : iWeekday2;

      iWeeks = Math.floor((dDate2.getTime() - dDate1.getTime()) / 604800000);

      if (iWeekday1 <= iWeekday2) {
        iDateDiff = iWeeks * 5 + (iWeekday2 - iWeekday1);
      } else {
        iDateDiff = (iWeeks + 1) * 5 - (iWeekday1 - iWeekday2);
      }

      iDateDiff -= iAdjust;

      return iDateDiff;
    },
    expectedCompletion(props) {
      var startDate = new Date(props.dateTimeReceived);
      var endDate = "",
        noOfDaysToAdd = props.processType.estimatedWorkingDays,
        count = 0;
      while (count < noOfDaysToAdd) {
        endDate = new Date(startDate.setDate(startDate.getDate() + 1));
        if (endDate.getDay() != 0 && endDate.getDay() != 6) {
          count++;
        }
      }
      return endDate;
    },
    async printTrackingReport() {
      var apiUrl = `dts/api/Report/Tracking`;
      var routeVariables = [];
      var body = [];
      this.tableData.forEach((item) => {
        if (item.selected) body.push({ id: item.id });
      });
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: body
      });
      this.$bvModal.show("print-options-modal");
    },
    async printSingleTrackingReport(id) {
      var apiUrl = `dts/api/Report/Tracking`;
      var routeVariables = [];
      var body = [];
      body.push({ id: id });
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: body
      });
      this.$bvModal.show("print-options-modal");
    }
  }
};
</script>
<template>
  <Layout @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <!-- Create Track -->
    <b-modal
      id="modal-documentTrack"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div v-if="formLoading" class="my-5">
        <div class="d-flex align-items-center justify-content-center">
          <div class="preloader-component me-2">
            <div class="status">
              <div class="spinner-chase w-25px h-25px">
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div>
          <div class="d-flex justify-content-end">
            <button
              type="button"
              @click="refreshOptions()"
              class="btn btn-sm btn-info"
            >
              <i class="mdi mdi-refresh"></i>
              Refresh Options
            </button>
          </div>
        </div>
        <div class="mb-3">
          <label for="title">Title </label>
          <input
            id="title"
            type="text"
            v-model="form.title"
            placeholder="Enter Title..."
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.form.title.$error
            }"
            autocomplete="off"
          />
          <div
            v-if="submitted && $v.form.title.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.title.required">This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="description">Description </label>
          <textarea
            id="description"
            type="text"
            v-model="form.description"
            placeholder="Enter Description..."
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.form.description.$error
            }"
            autocomplete="off"
          />
          <div
            v-if="submitted && $v.form.description.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.description.required"
              >This value is required.</span
            >
          </div>
        </div>
        <div class="mb-3">
          <label class="mt-2" for="documents">Particulars </label>
          <div>
            <b-input-group>
              <template #append>
                <button @click="addDocument()" class="btn btn-success">
                  Add
                </button>
              </template>
              <input
                autocomplete="off"
                type="text"
                placeholder="Enter Particular..."
                class="form-control"
                :class="{
                  'is-invalid': submitted && form.documents.length == 0
                }"
                v-model="form.document"
                @keyup.enter="addDocument()"
              />
            </b-input-group>
            <div
              v-if="submitted && form.documents.length == 0"
              class="invalid-feedback"
            >
              <span>This value is required.</span>
            </div>
          </div>
          <div
            v-if="form.documents.length > 0"
            class="mx-3 mt-2 p-2 br-5 border position-relative"
            style="min-height: 40px; background-color: #2e3446"
          >
            <div
              class="w-100"
              style="top: 10px; left: 10px; bottom: 10px; right: 10px"
            >
              <div class="multiselect__tags-wrap">
                <span
                  class="multiselect__tag"
                  v-for="(document, index) in form.documents"
                  :key="document.id"
                >
                  <span>{{ document }}</span>
                  <i
                    class="multiselect__tag-icon"
                    @click="removeDocument(index)"
                  ></i
                ></span>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label>Process </label>
          <multiselect
            id="processType"
            v-model="form.processType"
            track-by="processName"
            label="processName"
            placeholder="Select Process..."
            :custom-label="processTypeLabel"
            :show-labels="false"
            :options="processTypeOptions"
            :searchable="true"
            :multiple="false"
            :allow-empty="false"
            :close-on-select="true"
            :class="{
              'is-invalid': submitted && $v.form.processType.$error
            }"
            @input="changeProcessType()"
          >
          </multiselect>
          <div
            v-if="submitted && $v.form.processType.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.processType.required"
              >This value is required.</span
            >
          </div>
        </div>
        <b-collapse :visible="form.processType != null">
          <div v-if="form.processType != null">
            <div class="mb-3">
              <label>Action Request/Purpose </label>
              <multiselect
                id="actionType"
                v-model="form.actionType"
                track-by="type"
                label="type"
                placeholder="Select Action Request/Purpose..."
                :custom-label="actionTypeLabel"
                :show-labels="false"
                :options="actionTypeOptions"
                :searchable="true"
                :multiple="false"
                :allow-empty="false"
                :close-on-select="true"
                :class="{
                  'is-invalid': submitted && $v.form.actionType.$error
                }"
              >
              </multiselect>
              <b-collapse
                :visible="form.actionType && form.actionType.type == 'Others'"
              >
                <div
                  v-if="form.actionType && form.actionType.type == 'Others'"
                  class="mx-3 mt-2"
                >
                  <input
                    id="title"
                    type="text"
                    v-model="form.actionNeeded"
                    placeholder="Enter Action Request/Purpose..."
                    class="form-control"
                    :class="{
                      'is-invalid':
                        submitted &&
                        form.actionType.type == 'Others' &&
                        form.actionNeeded == ''
                    }"
                    autocomplete="off"
                  />
                </div>
              </b-collapse>
              <div
                v-if="
                  submitted &&
                    ($v.form.actionType.$error ||
                      (form.actionType.type == 'Others' &&
                        form.actionNeeded == ''))
                "
                class="invalid-feedback"
              >
                <span v-if="!$v.form.actionType.required"
                  >This value is required.</span
                >
              </div>
            </div>
            <label>Destination </label>
            <div class="border mb-3 px-3 py-2" style="border-radius: 5px">
              <div class="mb-3">
                <div class="d-flex justify-content-between">
                  <label for="destinationCampus">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} </label>
                  <div class="form-check form-checkbox-outline form-check-success mb-0">
                    <input
                        type="checkbox"
                        id="showAll"
                        class="form-check-input"
                        v-model="showAllCampus"
                    />
                    <label
                        for="showAll"
                        class="form-check-label no-wrap"
                    >
                        Show All
                    </label>
                  </div>
                </div>
                <multiselect
                  id="destinationCampus"
                  v-model="form.destinationCampus"
                  track-by="campus"
                  label="campus"
                  :placeholder="`Select ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}...`"
                  :custom-label="campusLabel"
                  :show-labels="false"
                  :options="campusOptions"
                  :searchable="true"
                  :multiple="false"
                  :allow-empty="false"
                  :close-on-select="true"
                  :class="{
                    'is-invalid': submitted && $v.form.destinationCampus.$error
                  }"
                >
                </multiselect>
                <div
                  v-if="submitted && $v.form.destinationCampus.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.destinationDeliveryUnit.required"
                    >This value is required.</span
                  >
                </div>
              </div>
              <b-collapse :visible="form.destinationCampus != null">
                <div v-if="form.destinationCampus != null">
                  <div class="mb-3">
                    <label>Office </label>
                    <multiselect
                      id="destinationDeliveryUnit"
                      v-model="form.destinationDeliveryUnit"
                      track-by="name"
                      label="name"
                      placeholder="Select Office..."
                      :custom-label="deliveryUnitLabel"
                      :show-labels="false"
                      :options="form.destinationCampus.deliveryUnitOptions"
                      :searchable="true"
                      :multiple="false"
                      :allow-empty="false"
                      :close-on-select="true"
                      @input="getDepartment(form.destinationDeliveryUnit.id)"
                      :class="{
                        'is-invalid':
                          submitted && $v.form.destinationDeliveryUnit.$error
                      }"
                    >
                    </multiselect>
                    <div
                      v-if="submitted && $v.form.destinationDeliveryUnit.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.destinationDeliveryUnit.required"
                        >This value is required.</span
                      >
                    </div>
                  </div>
                  <b-collapse :visible="form.destinationDeliveryUnit != null">
                    <div v-if="form.destinationDeliveryUnit != null">
                      <div class="mb-2">
                        <label>Department </label>
                        <multiselect
                          id="destinationDepartment"
                          v-model="form.destinationDepartment"
                          track-by="departmentName"
                          label="departmentName"
                          placeholder="Select Department..."
                          :custom-label="departmentLabel"
                          :show-labels="false"
                          :options="departmentOptions"
                          :searchable="true"
                          :multiple="false"
                          :allow-empty="false"
                          :close-on-select="true"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </b-collapse>
            </div>
          </div>
        </b-collapse>
        <div class="mb-3">
          <div class="d-flex float-end">
            <button
              type="button"
              @click="getTracks()"
              class="btn btn-sm btn-success"
            >
              Select Tracks
            </button>
          </div>
          <label class="mt-2">Link Track</label>
          <hr class="mt-1 mb-2" />
          <div style="max-height: 180px; overflow: auto" class="pe-2">
            <table v-if="form.tracks.length > 0" width="100%">
              <tbody>
                <tr v-for="(item, index) in form.tracks" :key="index">
                  <td class="py-2">
                    <div class="d-flex">
                      <div class="me-3">{{ index + 1 }}.</div>
                      <div>
                        <small>{{ item.referenceNumber }}</small>
                        <div>{{ item.title }}</div>
                      </div>
                    </div>
                  </td>
                  <td class="py-2" style="width: max-content">
                    <a
                      href="javascript: void(0);"
                      class="text-danger"
                      @click="form.tracks.splice(index, 1)"
                    >
                      <i class="bx bx-x font-size-18"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <i class="font-size-11" v-else>No Tracks Linked</i>
          </div>
          <hr class="my-2" />
        </div>
        <div v-if="form.id" class="d-flex float-end gap-1">
          <button @click="onSubmit('update')" class="btn btn-primary">
            Update Draft
          </button>
          <button @click="onSubmit('send')" class="btn btn-success">
            Update & Send
          </button>
        </div>
        <div v-else class="d-flex float-end gap-1">
          <button @click="onSubmit('create')" class="btn btn-primary">
            Create as Draft
          </button>
          <button @click="onSubmit('send')" class="btn btn-success">
            Create & Send
          </button>
        </div>
      </div>
    </b-modal>
    <!-- Main -->
    <div class="position-relative">
      <div
        v-if="tabIndex == 0"
        class="text-right position-absolute"
        style="right: 0"
      >
        <button
          type="button"
          @click="createTrack()"
          class="btn btn-sm btn-success d-flex align-items-center ms-1"
        >
          <i class="bx bx-plus fs-6 me-1"></i>Create Track
        </button>
      </div>
      <b-tabs
        content-class="text-muted"
        v-model="tabIndex"
        nav-class="nav-tabs-custom"
      >
        <!-- Draft -->
        <b-tab
          @click="
            getDraft();
            filter = '';
            currentPage = 1;
          "
        >
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-clipboard-multiple-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">Draft</span>
          </template>
          <div v-if="tabIndex == 0" class="py-2" style="min-width: 950px">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h5 class="mb-0">List of Tracks</h5>
              <div class="d-flex align-items-center">
                <div id="tickets-table_filter" class="dataTables_filter me-1">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-input
                      autocomplete="off"
                      @keyup="currentPage = 1"
                      v-model="filter"
                      type="search"
                      placeholder="Search Track..."
                      class="form-control"
                    ></b-form-input>
                  </label>
                </div>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-select
                      class="form-select"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    >
                    </b-form-select>
                  </label>
                </div>
              </div>
            </div>
            <b-card v-if="loading">
              <div class="d-flex align-items-center justify-content-center">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-25px h-25px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <h5 class="mb-0">Loading...</h5>
              </div>
            </b-card>
            <b-card class="text-center" v-else-if="paginated.length == 0">
              <div v-if="filter != ''">
                <i class="fas fa-exclamation-triangle me-2"></i>There are no
                tracks matching your request
              </div>
              <div v-else>
                <i class="fas fa-exclamation-triangle me-2"></i>No tracks
                available
              </div>
            </b-card>
            <div v-else class="text-muted">
              <b-card no-body class="m-0 mb-3">
                <b-card-header>
                  <div class="row align-items-center">
                    <div
                      class="col-6 cursor-pointer"
                      @click="sortData('track')"
                    >
                      <b :class="{ 'text-white': tableSort.sortBy == 'track' }"
                        >Process Track<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.trackReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-3 cursor-pointer"
                      @click="sortData('destination')"
                    >
                      <b
                        :class="{
                          'text-white': tableSort.sortBy == 'destination'
                        }"
                        >Destination<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.destinationReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-2 cursor-pointer"
                      @click="sortData('status')"
                    >
                      <b :class="{ 'text-white': tableSort.sortBy == 'status' }"
                        >Status<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.statusReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div class="col-1 text-end">
                      <b>Actions</b>
                    </div>
                  </div>
                </b-card-header>
              </b-card>
              <div role="tablist" v-for="(x, index) in paginated" :key="x.id">
                <div class="position-relative ms-1">
                  <RawData
                    :data="x"
                    v-if="$store.state.decrypt.isAdmin()"
                    :style="`z-index: ${paginated.length - index + 11}`"
                  />
                </div>
                <b-card
                  no-body
                  class="m-0 mb-3"
                  :style="`z-index: ${paginated.length - index + 10}`"
                >
                  <b-card-header>
                    <div class="row">
                      <div class="col-6">
                        <b class="text-white">{{ x.title }}</b>
                        <div class="d-flex align-items-center">
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-info"
                                @click="viewDetails(x.id)"
                              >
                                View Details
                              </a>
                            </small>
                          </div>
                          <span class="mx-2">|</span>
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-warning"
                                @click="viewLogs(x.id)"
                              >
                                View Logs
                              </a>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <div v-if="!x.destinationDepartment">
                          {{ x.destinationDeliveryUnit.name }}
                        </div>
                        <div v-else>
                          {{ x.destinationDepartment.departmentName }} ({{
                            x.destinationDeliveryUnit.name
                          }})
                        </div>
                      </div>
                      <div class="col-2">
                        <div v-if="x.status == 'DRAFT'">
                          <span class="text-info">CREATED</span> on
                          {{ formatDateWithTime(new Date(x.dateTimeCreated)) }}
                        </div>
                        <div v-if="x.status == 'RETURNED'">
                          <span class="text-warning">{{ x.status }}</span> on
                          {{ formatDateWithTime(new Date(x.dateTimePosted)) }}
                        </div>
                      </div>
                      <div class="col-1">
                        <div class="d-flex justify-content-end">
                          <i
                            class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                            :id="`draft-popover-${x.id}`"
                            tabindex="0"
                          ></i>
                          <b-popover
                            :target="`draft-popover-${x.id}`"
                            triggers="click blur"
                            placement="leftbottom"
                            variant="secondary"
                            custom-class="p-0"
                          >
                            <b-list-group class="w-100 fit">
                              <b-list-group-item
                                button
                                action
                                class="d-flex align-items-center text-success"
                                @click="postTrack(x)"
                                ><i class="bx bx-send font-size-18 me-1"></i
                                >Send Track</b-list-group-item
                              >
                              <b-list-group-item
                                button
                                action
                                class="d-flex align-items-center text-info"
                                @click="updateTrack(x)"
                                ><i class="bx bx-edit font-size-18 me-1"></i
                                >Update Track</b-list-group-item
                              >
                              <b-list-group-item
                                v-if="x.status == 'DRAFT'"
                                button
                                action
                                class="d-flex align-items-center text-danger"
                                @click="deleteTrack(x)"
                                ><i class="bx bx-trash font-size-18 me-1"></i
                                >Delete Track</b-list-group-item
                              >
                            </b-list-group>
                          </b-popover>
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                </b-card>
              </div>
            </div>
            <div class="row">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul
                    class="pagination pagination-rounded mb-0"
                    style="z-index: -1"
                  >
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <!-- In-Process -->
        <b-tab
          @click="
            getInProcess();
            filter = '';
            currentPage = 1;
          "
        >
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-clipboard-multiple-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">In-Process</span>
          </template>
          <div v-if="tabIndex == 1" class="py-2" style="min-width: 950px">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h5 class="mb-0">List of Tracks</h5>
              <div class="d-flex align-items-center">
                <div id="tickets-table_filter" class="dataTables_filter me-1">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-input
                      autocomplete="off"
                      @keyup="
                        resetSelected();
                        currentPage = 1;
                      "
                      v-model="filter"
                      type="search"
                      placeholder="Search Track..."
                      class="form-control"
                    ></b-form-input>
                  </label>
                </div>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-select
                      class="form-select"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    >
                    </b-form-select>
                  </label>
                </div>
              </div>
            </div>
            <b-card v-if="loading">
              <div class="d-flex align-items-center justify-content-center">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-25px h-25px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <h5 class="mb-0">Loading...</h5>
              </div>
            </b-card>
            <b-card class="text-center" v-else-if="paginated.length == 0">
              <div v-if="filter != ''">
                <i class="fas fa-exclamation-triangle me-2"></i>There are no
                tracks matching your request
              </div>
              <div v-else>
                <i class="fas fa-exclamation-triangle me-2"></i>No tracks
                available
              </div>
            </b-card>
            <div v-else class="text-muted">
              <div class="d-flex align-items-center mb-1">
                <div class="p-1 pe-0">
                  <div
                    class="form-check form-checkbox-outline form-check-success"
                  >
                    <input
                      type="checkbox"
                      id="checkbox-all"
                      checked="checked"
                      class="form-check-input"
                      @change="selectAllItems()"
                      v-model="selectAll"
                    />
                    <label for="checkbox-all" class="form-check-label">
                      Select All
                    </label>
                  </div>
                </div>
                <div class="ms-3">|</div>
                <transition name="slide">
                  <div
                    class="d-flex align-items-center"
                    v-if="checkForSelected()"
                  >
                    <button
                      type="button"
                      class="btn btn-sm btn-purple ms-3 d-flex align-items-center"
                      @click="printTrackingReport()"
                    >
                      <i class="bx bx-printer fs-6 me-1"></i>
                      Print Tracking Report
                    </button>
                  </div>
                </transition>
              </div>
              <b-card no-body class="m-0 mb-3">
                <b-card-header>
                  <div class="row align-items-center">
                    <div
                      class="col-4 cursor-pointer"
                      @click="sortData('track')"
                    >
                      <b :class="{ 'text-white': tableSort.sortBy == 'track' }"
                        >Process Track<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.trackReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-2 cursor-pointer"
                      @click="sortData('destination')"
                    >
                      <b
                        :class="{
                          'text-white': tableSort.sortBy == 'destination'
                        }"
                        >Destination<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.destinationReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-2 cursor-pointer"
                      @click="sortData('processType')"
                    >
                      <b
                        :class="{
                          'text-white': tableSort.sortBy == 'processType'
                        }"
                        >Process Type<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.processReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-2 cursor-pointer"
                      @click="sortData('duration')"
                    >
                      <b
                        :class="{
                          'text-white': tableSort.sortBy == 'duration'
                        }"
                        >Duration<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.durationReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-2 cursor-pointer"
                      @click="sortData('status')"
                    >
                      <b :class="{ 'text-white': tableSort.sortBy == 'status' }"
                        >Status<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.statusReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                  </div>
                </b-card-header>
              </b-card>
              <div role="tablist" v-for="(x, index) in paginated" :key="x.id">
                <div class="position-relative ms-1">
                  <RawData
                    :data="x"
                    v-if="$store.state.decrypt.isAdmin()"
                    :style="`z-index: ${paginated.length - index + 11}`"
                  />
                </div>
                <b-card
                  no-body
                  class="m-0 mb-3"
                  :style="`z-index: ${paginated.length - index + 10}`"
                >
                  <b-card-header>
                    <div class="row">
                      <div class="col-4">
                        <div
                          class="form-check form-checkbox-outline form-check-success"
                        >
                          <input
                            type="checkbox"
                            :id="`selected-${x.id}`"
                            class="form-check-input"
                            @change="checkSelected(paginated)"
                            v-model="x.selected"
                          />
                          <label
                            :for="`selected-${x.id}`"
                            class="form-check-label"
                          >
                            {{ x.referenceNumber }}
                          </label>
                        </div>
                        <b class="text-white">{{ x.title }}</b>
                        <div class="d-flex align-items-center">
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-info"
                                @click="viewDetails(x.id)"
                              >
                                View Details
                              </a>
                            </small>
                          </div>
                          <span class="mx-2">|</span>
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-warning"
                                @click="viewLogs(x.id)"
                              >
                                View Logs
                              </a>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-2">
                        <div v-if="!x.destinationDepartment">
                          {{ x.destinationDeliveryUnit.name }}
                        </div>
                        <div v-else>
                          {{ x.destinationDepartment.departmentName }} ({{
                            x.destinationDeliveryUnit.name
                          }})
                        </div>
                      </div>
                      <div class="col-2">
                        <div>
                          {{ x.processType.processName }}
                        </div>
                        <small>
                          {{ x.processType.easeOfDoingBusinessType }}
                        </small>
                      </div>
                      <div class="col-2">
                        <div v-if="x.status == 'RECEIVED'">
                          <div>
                            Days since received: (
                            <b
                              :class="
                                x.processType.estimatedWorkingDays <
                                processDuration(x)
                                  ? 'text-danger'
                                  : x.processType.daysToRemindOfficeProcessor <
                                    processDuration(x)
                                  ? 'text-warning'
                                  : 'text-success'
                              "
                            >
                              {{ processDuration(x) }} </b
                            >)
                          </div>
                          <div v-if="x.note">
                            <div class="d-flex gap-1">
                              <div><small>Notes: </small></div>
                              <div>
                                <small>{{ x.note }}</small>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else class="text-secondary">N/A</div>
                      </div>
                      <div class="col-2">
                        <div v-if="x.status == 'PENDING'">
                          <div>
                            <span class="text-info">SENT</span> on
                            {{ formatDate(new Date(x.dateTimePosted)) }}
                          </div>
                          <button
                            type="button"
                            @click="unsendTrack(x)"
                            class="btn btn-sm btn-warning d-flex align-items-center mt-2"
                          >
                            <i class="bx bx-undo fs-6 me-1"></i>Unsend Track
                          </button>
                        </div>
                        <div v-if="x.status == 'RETURNED'">
                          <span class="text-warning">{{ x.status }}</span> on
                          {{ formatDate(new Date(x.dateTimePosted)) }}
                        </div>
                        <div v-if="x.status == 'RECEIVED'">
                          <div class="font-size-12">
                            <span class="text-pink">{{ x.status }}</span> on
                            {{ formatDate(new Date(x.dateTimeReceived)) }}
                          </div>
                          <div class="font-size-12">
                            To be <span class="text-purple">COMPLETED</span> on
                            {{ formatDate(new Date(expectedCompletion(x))) }}
                          </div>
                        </div>
                        <div v-if="x.status == 'COMPLETED'">
                          Currently <span class="text-purple">FORWARDED</span>
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                </b-card>
              </div>
            </div>
            <div class="row">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div
                  @click="checkSelected(paginated)"
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul
                    class="pagination pagination-rounded mb-0"
                    style="z-index: -1"
                  >
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <!-- Processed -->
        <b-tab
          @click="
            getProcessed();
            filter = '';
            currentPage = 1;
          "
        >
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-clipboard-multiple-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">Processed</span>
          </template>
          <div v-if="tabIndex == 2" class="py-2" style="min-width: 950px">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h5 class="mb-0">List of Tracks</h5>
              <div class="d-flex align-items-center">
                <div id="tickets-table_filter" class="dataTables_filter me-1">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-input
                      autocomplete="off"
                      @keyup="
                        resetSelected();
                        currentPage = 1;
                      "
                      v-model="filter"
                      type="search"
                      placeholder="Search Track..."
                      class="form-control"
                    ></b-form-input>
                  </label>
                </div>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-select
                      class="form-select"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    >
                    </b-form-select>
                  </label>
                </div>
              </div>
            </div>
            <b-card v-if="loading">
              <div class="d-flex align-items-center justify-content-center">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-25px h-25px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <h5 class="mb-0">Loading...</h5>
              </div>
            </b-card>
            <b-card class="text-center" v-else-if="paginated.length == 0">
              <div v-if="filter != ''">
                <i class="fas fa-exclamation-triangle me-2"></i>There are no
                tracks matching your request
              </div>
              <div v-else>
                <i class="fas fa-exclamation-triangle me-2"></i>No tracks
                available
              </div>
            </b-card>
            <div v-else class="text-muted">
              <div class="d-flex align-items-center mb-1">
                <div class="p-1 pe-0">
                  <div
                    class="form-check form-checkbox-outline form-check-success"
                  >
                    <input
                      type="checkbox"
                      id="checkbox-all"
                      checked="checked"
                      class="form-check-input"
                      @change="selectAllItems()"
                      v-model="selectAll"
                    />
                    <label for="checkbox-all" class="form-check-label">
                      Select All
                    </label>
                  </div>
                </div>
                <div class="ms-3">|</div>
                <transition name="slide">
                  <div
                    class="d-flex align-items-center"
                    v-if="checkForSelected()"
                  >
                    <button
                      type="button"
                      class="btn btn-sm btn-purple ms-3 d-flex align-items-center"
                      @click="printTrackingReport()"
                    >
                      <i class="bx bx-printer fs-6 me-1"></i>
                      Print Tracking Report
                    </button>
                  </div>
                </transition>
              </div>
              <b-card no-body class="m-0 mb-3">
                <b-card-header>
                  <div class="row align-items-center">
                    <div
                      class="col-7 cursor-pointer"
                      @click="sortData('track')"
                    >
                      <b :class="{ 'text-white': tableSort.sortBy == 'track' }"
                        >Process Track<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.trackReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-3 cursor-pointer"
                      @click="sortData('destination')"
                    >
                      <b
                        :class="{
                          'text-white': tableSort.sortBy == 'destination'
                        }"
                        >Destination<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.destinationReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-2 cursor-pointer"
                      @click="sortData('status')"
                    >
                      <b :class="{ 'text-white': tableSort.sortBy == 'status' }"
                        >Status<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.statusReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                  </div>
                </b-card-header>
              </b-card>
              <div role="tablist" v-for="(x, index) in paginated" :key="x.id">
                <div class="position-relative ms-1">
                  <RawData
                    :data="x"
                    v-if="$store.state.decrypt.isAdmin()"
                    :style="`z-index: ${paginated.length - index + 11}`"
                  />
                </div>
                <b-card
                  no-body
                  class="m-0 mb-3"
                  :style="`z-index: ${paginated.length - index + 10}`"
                >
                  <b-card-header>
                    <div class="row">
                      <div class="col-7">
                        <div
                          class="form-check form-checkbox-outline form-check-success"
                        >
                          <input
                            type="checkbox"
                            :id="`selected-${x.id}`"
                            class="form-check-input"
                            @change="checkSelected(paginated)"
                            v-model="x.selected"
                          />
                          <label
                            :for="`selected-${x.id}`"
                            class="form-check-label"
                          >
                            {{ x.referenceNumber }}
                          </label>
                        </div>
                        <b class="text-white">{{ x.title }}</b>
                        <div class="d-flex align-items-center">
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-info"
                                @click="viewDetails(x.id)"
                              >
                                View Details
                              </a>
                            </small>
                          </div>
                          <span class="mx-2">|</span>
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-warning"
                                @click="viewLogs(x.id)"
                              >
                                View Logs
                              </a>
                            </small>
                          </div>
                          <span v-if="!x.withRating" class="mx-2">|</span>
                          <div v-if="!x.withRating">
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-pink"
                                @click="trackRating(x.id)"
                              >
                                Rate Track
                              </a>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <div v-if="!x.destinationDepartment">
                          {{ x.destinationDeliveryUnit.name }}
                        </div>
                        <div v-else>
                          {{ x.destinationDepartment.departmentName }} ({{
                            x.destinationDeliveryUnit.name
                          }})
                        </div>
                      </div>
                      <div class="col-2">
                        <div>
                          <span class="text-success">PROCESSED</span> on
                          {{ formatDateWithTime(new Date(x.actionDateTime)) }}
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                </b-card>
              </div>
            </div>
            <div class="row">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div
                  @click="checkSelected(paginated)"
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul
                    class="pagination pagination-rounded mb-0"
                    style="z-index: -1"
                  >
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <Details
      user="office"
      @updateTrack="updateTrack($event)"
      @postTrack="postTrack($event)"
      @unsendTrack="unsendTrack($event)"
      @deleteTrack="deleteTrack($event)"
      @printTrackingReport="printSingleTrackingReport($event)"
      ref="details"
    ></Details>
    <Logs @viewDetails="viewDetails($event)" ref="logs"></Logs>
    <Rating ref="rating" @saveRating="saveRating($event)"></Rating>
    <Tracks ref="tracks" @dropMultiple="dropTracks($event)"></Tracks>
    <print-options ref="printOpt"></print-options>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}

.multiselect__option--group {
  padding-top: 16px;
  padding-bottom: 0;
  background: #2a3042 !important;
  color: #bfc8e2 !important;
  font-weight: bold !important;
  font-size: medium !important;
}
</style>